var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEditNotactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.926 10.382c-1.741-1.432-2.747-0.957-3.288-0.307l-6.562 7.992c-0.019 0.024-0.024 0.053-0.040 0.077-0.12 0.13-0.219 0.283-0.251 0.47l-0.637 3.574c-0.061 0.342 0.069 0.691 0.338 0.91 0.173 0.144 0.389 0.218 0.608 0.218 0.118 0 0.237-0.021 0.35-0.066l3.378-1.323c0.178-0.069 0.307-0.195 0.413-0.338 0.021-0.022 0.050-0.032 0.069-0.054l6.562-7.99c0.533-0.651 0.803-1.73-0.939-3.163zM12.634 19.202l4.106-5.002 1.166 0.96c0.032 0.026 0.069 0.035 0.102 0.058l-4.118 5.014-1.549 0.608 0.293-1.638zM19.198 13.766c-0.029-0.029-0.043-0.066-0.075-0.091l-1.166-0.962 1.077-1.31c0.112 0.050 0.323 0.171 0.675 0.461 0.35 0.288 0.509 0.47 0.582 0.57l-1.093 1.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 1.947c-7.747 0.002-14.051 6.306-14.053 14.053 0.002 7.749 6.304 14.053 14.050 14.053h0.003c7.75 0 14.053-6.302 14.053-14.053 0.002-7.747-6.301-14.051-14.053-14.053zM15.997 28.134c-6.688-0.002-12.128-5.443-12.13-12.134 0.002-6.69 5.443-12.131 12.133-12.133 3.24 0 6.29 1.262 8.579 3.555 2.293 2.29 3.555 5.338 3.555 8.578 0 6.691-5.445 12.134-12.138 12.134z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditNotactive);
export default __webpack_public_path__ + "static/media/icon-edit-notactive.434f2b94.svg";
export { ForwardRef as ReactComponent };